/**
 * Custom hook for onboarding page interactions.
 * Feature: 016-onboarding-conversation
 *
 * Provides TanStack Query integration for saving onboarding pages.
 */

import { useMutation } from '@tanstack/react-query';
import { saveOnboardingPage } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

interface SavePageData {
  page: 'personal_details' | 'goals' | 'body_state' | 'struggles';
  data: any;
}

export const useOnboarding = () => {
  const { updateUser } = useAuth();

  const savePage = useMutation({
    mutationFn: ({ page, data }: SavePageData) => saveOnboardingPage(page, data),
    onSuccess: (response) => {
      // Update AuthContext with new user data (includes updated onboarding progress)
      updateUser(response);
    },
  });

  return {
    savePage,  // Return entire mutation object with mutate, mutateAsync, etc.
    isSaving: savePage.isPending,
    error: savePage.error,
  };
};
